import qs from 'qs';
import moment from 'moment';

import umbraco from '@/config/umbrac.json';

export default {
    name: 'GlobalMixins',

    data() {
        return {
            vue_app_type: process.env.VUE_APP_TYPE,
            globalLoading: false,
            meta: {
                title: {
                    value: '',
                    template: ''
                },
                metadata: [
                    {
                        name: 'og:type',
                        content: "website"
                    },
                    {
                        name: 'Content-Type',
                        content: 'text/html; charset=utf-8'
                    },
                    {
                        name: 'viewport',
                        content: 'width=device-width, initial-scale=1, shrink-to-fit=no'
                    }
                ],
                script: [],
                style: [],
                link: [],
                base: {},
                htmlAttrs: {
                    lang: 'en',
                    amp: true
                },
                headAttrs: {},
                bodyAttrs: {}
            },
            breadcrumbs: null,
            footer: null,
            header: null,
            body: null
        }
    },

    metaInfo() {
        return this.meta;
    },

    computed: {
        globalMessages() {
            return this.$store.getters['globalMessages/list'];
        },
        pageTabs() {
            return this.$store.getters['tabs/list'];
        }
    },

    methods: {

        isActiveMenu(menu) {

            if (menu.route && menu.route.url) {
                let l1 = menu.route.url.replace(/(http)[s]?:\/\//, '');
                let l2 = process.env.VUE_APP_DOMAIN.replace(/(http)[s]?:\/\//, '');
                l2 += this.$route.path;
                return (l1 === l2 || l1 === `${l2}/`);
            }

            return false;
        },

        resetPage(resetMeta = false) {
            if (resetMeta) {
                this.meta = {
                    title: {
                        value: '',
                        template: ''
                    },
                    metadata: [],
                    script: [],
                    style: [],
                    link: [],
                    base: {},
                    htmlAttrs: {},
                    headAttrs: {},
                    bodyAttrs: {}
                };
            }

            this.breadcrumbs = null;
            this.body = null;
        },

        validEmail: function (email) {
            /* eslint-disable */
            let re = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
            return re.test(email);
        },

        validPassword: function (pass) {
            /* eslint-enable */
            let re = /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\s*.!@$%^&(){}[]:;<>,.?\/~_+-=|\\]).{10,32}$/;
            return re.test(pass);
        },

        getURLLocalGlobal: function (url) {
            let mydomain = process.env.VUE_APP_DOMAIN.replace(/(http)[s]?:\/\//, '');
            let localDomainRegex = /(http)[s]?:\/\/(localhost):[0-9]{4}/;
            if (url.includes(mydomain)) {
                url = url.replace(/(http)[s]?:\/\//, '').replace(mydomain, '');
                return url;
            } else if (localDomainRegex.test(url)) {
                return url.replace(localDomainRegex, '');
            }
            return url.replace(/\/\/#/g, '/#');
        },

        getAnchorFromUrl: function (url) {
            if (url.indexOf('#') !== -1) {
                let newUrl = url.split('#');
                return {url: newUrl[0], anchor: newUrl[1]};
            }
            return null;
        },

        getAnchorFromRoute: function () {
            const _self = this;
            if (this.$router.currentRoute.hash) {
                setTimeout(() => {
                    let anchor = _self.$router.currentRoute.hash.replace('#', '');
                    if (anchor.trim() !== '') {
                        _self.scrollMeTo(anchor);
                    }
                }, 1000);
            }
        },

        goToPage: function (element, $event, cb) {
            $event.preventDefault();

            if (typeof element === 'string') {
                element = {
                    route: {
                        url: element,
                        target: ''
                    }
                };
            }

            const myRoute = element.route;

            if (myRoute && myRoute.url) {
                let routeUrl = this.getURLLocalGlobal(myRoute.url);

                let anchorInUrl = this.getAnchorFromUrl(routeUrl);
                if (anchorInUrl) {
                    if (this.$router.currentRoute.path == anchorInUrl.url) {
                        this.scrollMeTo(anchorInUrl.anchor);
                    } else {
                        let page = this.getPage(routeUrl);
                        if (page.target && page.target === '_blank') {
                            window.open(`${process.env.VUE_APP_DOMAIN}${myRoute.url}`);
                        } else {
                            this.$router.push({path: routeUrl, params: page.params});
                        }
                    }

                } else if (routeUrl.includes('http://') || routeUrl.includes('https://')) {
                    if (myRoute.target && myRoute.target === '_blank') {
                        window.open(myRoute.url);
                    } else {
                        window.location.href = myRoute.url;
                    }
                } else if (this.$router.currentRoute.path !== routeUrl) {
                    let page = this.getPage(routeUrl);
                    if (page.target && page.target === '_blank') {
                        window.open(`${process.env.VUE_APP_DOMAIN}${myRoute.url}`);
                    } else {
                        this.$router.push({path: routeUrl, params: page.params});
                    }
                }
            }
            if (cb && typeof cb === 'function') {
                return cb();
            }
        },

        getPage: function (myRoute) {
            let routeData = this.$router.resolve(myRoute);
            if (routeData && this.$router.currentRoute.path !== myRoute.url) {
                return {route: routeData.route, params: myRoute.params || {}, target: myRoute.target};
            } else return null;
        },

        licenseError() {
            this.pushMessage({
                type: 'error',
                title: 'Error: 132',
                text: 'The provided license key is not authorized to work from your IP address!'
            });
        },

        clearMessages() {
            this.$store.dispatch('globalMessages/clear');
        },

        pushMessage(context) {
            this.$store.dispatch('globalMessages/push', {
                type: context.type,
                title: context.title,
                text: context.text
            });
            this.scrollToTop();
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        executeRequest(context) {
            const APIHeaders = context.headers || {};

            APIHeaders['env'] = process.env.VUE_APP_M360_ENV || 'dev';
            APIHeaders['x-key'] = this.$store.getters['key/getKey'];

            const requestOptions = {
                url: context.url,
                method: (context.method || 'GET').toUpperCase(),
                headers: APIHeaders,
            };

            if (!['POST', 'PATCH', 'PUT'].includes(requestOptions.method)) {
                requestOptions.params = context.params;
            } else {
                requestOptions.data = context.params;
            }

            if (context.qs) {
                requestOptions.params = context.qs;
            }

            if (context.body) {
                requestOptions.data = context.body;
            }

            if (context.blob) {
                requestOptions.responseType = 'blob';
            }

            requestOptions.paramsSerializer = function (params) {
                return qs.stringify(params, {arrayFormat: 'repeat'});
            };

            return this.$http(requestOptions).then(response => {
                if (context.blob) {
                    return Promise.resolve(response);
                }

                if (!response.data.data) {
                    console.error('Invalid response format: ' + JSON.stringify(response.data));
                    return response.data;
                }
                return response.data.data;
            }).catch(error => {
                // normalize error
                const errorRes = {};
                if (error.response) {
                    if (error.response.status) errorRes.status = error.response.status;
                    if (error.response.data) {
                        if (error.response.data.errors) {
                            errorRes.errors = error.response.data.errors;
                        } else if (error.response.data.error) {
                            const code = Object.keys(error.response.data.statusCode)[0];
                            errorRes.errors = {};
                            errorRes.errors[code] = {
                                code,
                                message: error.response.data.message
                            };
                        }
                    }
                }
                if (!errorRes.status) errorRes.status = 500;
                if (!errorRes.errors) errorRes.errors = {
                    '500': {
                        code: 500,
                        message: 'An internal error occurred'
                    }
                };
                const code = Object.keys(errorRes.errors)[0];
                errorRes.message = errorRes.errors[code].message;
                // throw normalized error
                throw errorRes;
            });
        },

        async getSendData(context) {
            const self = this;

            function forceLogout(errors) {
                self.clearMessages();
                setTimeout(() => {
                    printErrors(errors);
                }, 1000);
            }

            function printErrors(errors) {
                for (let code in errors) {
                    self.$store.dispatch('globalMessages/push', {
                        type: 'error',
                        title: `Error ${code}`,
                        text: errors[code].message
                    });
                }
                self.scrollToTop();
            }

            if (!context.noLoading) {
                self.$emit('triggerOverlayLoading', true);
            }

            self.clearMessages();
            return self.executeRequest(context)
                .then(data => data)
                .catch(error => {
                    if (context.bypass) {
                        throw error;
                    } else if (error.status === 520 && error.errors['142'] || error.errors['1008']) {
                        if (context.method === 'delete' && context.url === process.env.VUE_APP_LOGIN_API) {
                            forceLogout(error.errors);
                            throw error;
                        } else {
                            forceLogout(error.errors);
                            throw error;
                        }
                    } else {
                        if (!context.skipErrors) {
                            printErrors(error.errors);
                        }
                        throw error;
                    }
                }).finally(() => {
                    if (!context.noLoading) {
                        self.$emit('triggerOverlayLoading', false);
                    }
                });
        },

        async checkFixProperties(section) {

            const _self = this;
            const reservedElements = ['elements', 'route', 'sections', 'defaultStyle', 'aspectRatio'];

            function fixPropertyName(oldName) {
                if (typeof oldName !== 'string') {
                    return oldName;
                }

                if (umbraco && umbraco[oldName]) {
                    return umbraco[oldName]
                } else {
                    let newName = '';
                    if (oldName.includes('elevate')) {
                        newName = oldName;
                    } else {
                        newName = oldName.replace('ele', '');
                    }
                    newName = newName.charAt(0).toLowerCase() + newName.slice(1);
                    if (/^([a-z]+)(([A-Z]([a-z]+))+)$/.test(newName)) {
                        newName = _self._.snakeCase(newName).replace(/[_]/g, '-');

                        if (!newName.includes('v-')) {
                            newName = `v-${newName}`;
                        }
                    }
                    return newName;
                }
            }

            function fixPropertiesNames(properties) {
                for (let key in properties) {
                    let newKey = fixPropertyName(key);
                    if (key !== newKey) {
                        properties[newKey] = _self._.cloneDeep(properties[key]);
                        delete properties[key];
                    }
                }
            }

            function iterateUpdateSectionProperties(section) {
                if (Array.isArray(section)) {
                    for (let i = 0; i < section.length; i++) {
                        iterateUpdateSectionProperties(section[i]);
                    }
                    _self.$forceUpdate();
                } else if (typeof (section) === 'object') {
                    for (let i in section) {
                        if (i === 'type') {
                            section.vuetify = fixPropertyName(section.type);
                            if (
                                section.type == 'eleAbstract' &&
                                section.properties &&
                                section.properties.template
                            ) {
                                if (section.properties.data.items) {
                                    section.properties.data.items.forEach((oneItem) => {
                                        for (let i in oneItem) {
                                            if (
                                                typeof oneItem[i] === 'string' &&
                                                (oneItem[i].includes('http://') || oneItem[i].includes('https://'))
                                            ) {
                                                oneItem[i] = _self.getURLLocalGlobal(oneItem[i]);
                                            }
                                        }
                                    });
                                }
                                if (section.properties.data.medias) {
                                    section.properties.data.medias.forEach((oneItem) => {
                                        for (let i in oneItem) {
                                            if (
                                                typeof oneItem[i] === 'string' &&
                                                (oneItem[i].includes('http://') || oneItem[i].includes('https://'))
                                            ) {
                                                oneItem[i] = _self.getURLLocalGlobal(oneItem[i]);
                                            }
                                        }
                                    });
                                }

                                if (section.properties.template.includes(':displayType=')) {
                                    let type = section.properties.template.match(/(displayType=")[a-z0-9A-Z]+"/);
                                    type = type[0].replace(type[1], '').replace('"', "");
                                    section.type = 'ele' + type;
                                    section.vuetify = fixPropertyName(section.type);
                                    section.properties.template = section.properties.template.replace(`:displayType="${type}"`, '');
                                }
                                _self.$forceUpdate();
                            }
                            _self.$forceUpdate();
                        } else if (i === 'properties') {
                            //adjust special reserved words
                            reservedElements.forEach((oneReservedElement) => {
                                if (section.properties[oneReservedElement]) {
                                    section[oneReservedElement] = _self._.cloneDeep(section.properties[oneReservedElement]);
                                    delete section.properties[oneReservedElement];
                                    for (let j = 0; j < section[oneReservedElement].length; j++) {
                                        iterateUpdateSectionProperties(section[oneReservedElement][j]);
                                    }
                                    _self.$forceUpdate();
                                }
                            });

                            fixPropertiesNames(section.properties);
                            _self.$forceUpdate();
                        } else {
                            iterateUpdateSectionProperties(section[i]);
                            _self.$forceUpdate();
                        }
                    }
                }
            }

            iterateUpdateSectionProperties(section);
        },

        async loadDataInfo(pageUrl) {
            if (!pageUrl || pageUrl.trim() === '') {
                return null;
            }

            this.$emit('triggerOverlayLoading', true);
            let requestOptions = {
                url: '/abcbridgeapi/',
                method: 'post',
                body: {
                    route: pageUrl
                }
            };

            return this.getSendData(requestOptions)
                .then(response => {
                    if (response) {
                        return response;
                    }
                    this.$emit('triggerOverlayLoading', false);
                })
                .catch(error => {
                    if (error && error.errors && error.errors[132] && error.errors[132].message) {
                        this.clearMessages();
                        this.licenseError();
                    } else throw error;
                });
        },

        stripHtml(html) {
            let tmp = document.createElement("DIV");
            tmp.innerHTML = html;
            return tmp.textContent || tmp.innerText || "";
        },

        async updatePageMetaInfo(context) {
            if (context.name) {
                this.meta.metadata.push({
                    vmid: 'og:title',
                    name: 'og:title',
                    property: 'og:title',
                    content: context.name
                });

                this.meta.metadata.push({
                    vmid: 'og:site_name',
                    name: 'og:site_name',
                    property: 'og:site_name',
                    content: context.name
                });

            }

            if (context.title) {
                this.meta.title.value = this.meta.title.titleChunk = this.meta.title.template = this.stripHtml(context.title);

                let found = false;
                this.meta.metadata.forEach((oneMeta) => {
                    if (oneMeta.vmid === 'og:title') {
                        found = true;
                        oneMeta.content = this.stripHtml(context.title)
                    }

                    if (oneMeta.vmid === 'og:site_name') {
                        found = true;
                        oneMeta.content = this.stripHtml(context.title)
                    }
                });
                if (!found) {
                    this.meta.metadata.push({
                        vmid: 'og:title',
                        name: 'og:title',
                        property: 'og:title',
                        content: this.stripHtml(context.title)
                    });
                    this.meta.metadata.push({
                        vmid: 'og:site_name',
                        name: 'og:site_name',
                        property: 'og:site_name',
                        content: this.stripHtml(context.title)
                    });

                }
            }

            if (context.description) {
                let found = false;
                this.meta.metadata.forEach((oneMeta) => {
                    if (oneMeta.vmid === 'og:description') {
                        found = true;
                        oneMeta.content = context.description
                    }

                    if (oneMeta.vmid === 'og:description') {
                        found = true;
                        oneMeta.content = context.description
                    }
                });
                if (!found) {
                    this.meta.metadata.push({
                        vmid: 'og:description',
                        name: 'og:description',
                        property: 'og:description',
                        content: context.description
                    });
                    this.meta.metadata.push({
                        vmid: 'description',
                        name: 'description',
                        content: context.description
                    });
                }
            }

            if (context.favicon) {
                this.meta.link.push({
                    vmid: 'icon',
                    rel: 'icon',
                    href: context.favicon
                });

                this.meta.metadata.push({
                    vmid: 'favicon',
                    name: 'favicon',
                    href: context.favicon
                });
            }

            if (context.protected) {
                for (let i = this.meta.metadata.length - 1; i >= 0; i--) {
                    if (this.meta.metadata[i].vmid === 'protected') {
                        this.meta.metadata.splice(i, 1);
                        break;
                    }
                }
            } else {
                for (let i = this.meta.metadata.length - 1; i >= 0; i--) {
                    if (this.meta.metadata[i].vmid === 'protected') {
                        this.meta.metadata.splice(i, 1);
                    } else if (this.meta.metadata[i].vmid === 'protected-groups') {
                        this.meta.metadata.splice(i, 1);
                    }
                }
            }

            if (context.pageImage) {
                this.meta.metadata.push({
                    name: 'og:image',
                    property: 'og:image',
                    content: context.pageImage
                });
                this.meta.metadata.push({
                    name: 'msapplication-TileImage',
                    content: context.pageImage
                });
            }

            if (context.global) {
                if (context.global.link && Array.isArray(context.global.link)) {
                    context.global.link.forEach((oneLink) => {
                        this.meta.link.push({
                            rel: 'stylesheet',
                            href: oneLink
                        });
                    })
                }

                if (context.global.scripts && Array.isArray(context.global.scripts)) {
                    context.global.scripts.forEach((oneScript) => {
                        this.meta.script.push({
                            async: true,
                            defer: true,
                            src: oneScript
                        });
                    })
                }
            }

            if (context.msTilePicker) {
                this.meta.metadata.push({
                    name: 'msapplication-TileColor',
                    content: context.msTilePicker
                });
            }

            if (context.chromeThemeColor) {
                this.meta.metadata.push({
                    name: 'theme-color',
                    content: context.chromeThemeColor
                });
            }

            if (context.metadata) {
                context.metadata.forEach((oneMetaData) => {
                    this.meta.metadata.push({
                        name: oneMetaData.properties.metaName,
                        'data-type': oneMetaData.properties['data-type'] || 'text',
                        content: oneMetaData.properties.content
                    });
                });
            }

            let robots = {
                vmid: 'robots',
                name: 'robots',
                content: 'noindex'
            };
            if (context.searchEngineVisible) {
                robots.content = 'index';

                if (context.searchEngineCrawl) {
                    robots.content += ', follow';
                }
            }
            let robotsFound = false;
            for (let i = 0; i < this.meta.metadata.length; i++) {
                if (this.meta.metadata[i].vmid === robots.vmid) {
                    this.meta.metadata[i] = robots;
                    robotsFound = true;
                    break;
                }
            }
            if (!robotsFound) {
                this.meta.metadata.push(robots);
            }
            this.$forceUpdate();
            return this.meta;
        },

        async checkSetElementBackground(context, section = false) {
            if (context.properties && context.properties.background && context.properties.background.length > 0) {
                context.background = {};
                let selectedBackground = this._.cloneDeep(context.properties.background[0]);

                if (selectedBackground.type === 'video') {
                    context.background.video = {
                        media: {},
                        properties: {}
                    };
                    context.background.video.media = {
                        type: selectedBackground.properties.type,
                        src: selectedBackground.properties.srcCrop || selectedBackground.properties.src
                    };
                    delete selectedBackground.properties.type;
                    delete selectedBackground.properties.src;
                    delete selectedBackground.properties.srcCrop;

                    context.background.video.properties.poster = selectedBackground.properties.videoPosterCrop || selectedBackground.properties.videoPoster;
                    delete selectedBackground.properties.videoPoster;
                    delete selectedBackground.properties.videoPosterCrop;

                    if (!selectedBackground.properties.style) {
                        selectedBackground.properties.style = {};
                    }

                    selectedBackground.properties.style['object-fit'] = 'cover';
                    if (context.properties && context.properties.style && context.properties.style.height) {
                        selectedBackground.properties.style['height'] = context.properties.style.height;
                    }
                    this._.merge(context.background.video.properties, selectedBackground.properties);
                } else if (selectedBackground.type === 'backgroundImage') {
                    context.background.image = this._.cloneDeep(selectedBackground.properties);

                    let holder = (section) ? context.bg : context.properties;
                    if (!holder) {
                        holder = {};
                    }

                    if (!holder.style) {
                        holder.style = {};
                    }

                    holder.style['background-image'] = `url(${context.background.image.srcCrop || context.background.image.src})`;

                    if (context.background.image.size) {
                        holder.style['background-size'] = context.background.image.size;
                    }

                    if (context.background.image.repeat) {
                        holder.style['background-repeat'] = context.background.image.repeat.toLowerCase();
                    }

                    if (context.background.image.position) {
                        holder.style['background-position'] = context.background.image.position.toLowerCase();
                    }

                    if (section) {
                        context.bg = holder;
                    } else {
                        context.properties = holder;
                    }
                } else if (selectedBackground.type === 'backgroundColor') {
                    context.background.color = this._.cloneDeep(selectedBackground.properties);

                    let holder = (section) ? context.bg : context.properties;
                    if (!holder) {
                        holder = {};
                    }

                    if (!holder.style) {
                        holder.style = {};
                    }
                    holder.style['background-color'] = `${context.background.color.color} !important`;

                    if (section) {
                        context.bg = holder;
                    } else {
                        context.properties = holder;
                    }
                }

                if (section) {
                    if (!context.bg) {
                        context.bg = {};
                    }
                    if (!context.bg.class) {
                        context.bg.class = '';
                    }
                    context.bg.class += ' m360-relative-section';
                } else {
                    if (!context.properties.class) {
                        context.properties.class = '';
                    }

                    context.properties.class += ' m360-relative-section';
                }

                delete context.properties.background;
                this.$forceUpdate();
                return true;
            } else
                return true;
        },

        doLogout() {

        },

        async hookAllLinks() {
            const _self = this;
            let elements = document.getElementsByTagName('a');

            if (elements) {
                if (Array.isArray(elements) && elements.length > 0) {
                    elements.forEach((oneLinkElement) => {
                        if (typeof oneLinkElement === 'object') {
                            updateElementLinkValue(oneLinkElement);
                        }
                    });
                } else if (typeof elements === 'object') {
                    for (let oneLinkElement in elements) {
                        if (typeof elements[oneLinkElement] === 'object') {
                            updateElementLinkValue(elements[oneLinkElement]);
                        }
                    }
                }
            }

            function updateElementLinkValue(oneLinkElement) {
                if (
                    !oneLinkElement.linkUpdated &&
                    oneLinkElement.href
                    && oneLinkElement.href !== '#'
                ) {
                    oneLinkElement.onclick = function (event) {
                        oneLinkElement.href = _self.getURLLocalGlobal(oneLinkElement.href);
                        _self.goToPage({
                            route: {
                                url: oneLinkElement.href,
                                target: oneLinkElement.target
                            }
                        }, event);
                    };
                }

                oneLinkElement.linkUpdated = true;
            }
        },

        async setPageMeta(pageInfo) {
            await this.updatePageMetaInfo(pageInfo);

            if (pageInfo.footer) {
                this.footer = pageInfo.footer;
            } else if (pageInfo.disableFooter) {
                this.footer = null;
            }

            if (pageInfo.header) {
                if (Array.isArray(pageInfo.header)) {
                    this.header = pageInfo.header;
                } else {
                    this.header = [pageInfo.header];
                }
            } else if (pageInfo.disableHeader) {
                this.header = null;
            }

            if (pageInfo.paths) {
                this.breadcrumbs = pageInfo.paths;
            }

            if (pageInfo.menu) {
                this.triggerRerenderMenu(pageInfo.menu);
            }

            //no header was sent via globals nor via the override
            //header might also been disabled, same use case
            if (!this.header) {
                this.$emit('headerSuppressed', true);
            }
        },

        async setGlobalDefaults() {
            this.globals = this._.cloneDeep(this.defaultGlobals);
            await this.updatePageMetaInfo(this.globals);

            if (this.globals.header) {
                this.header = this.globals.header;
            }

            if (this.globals.footer) {
                this.footer = this.globals.footer;
            }
        },

        scrollMeTo(refName) {
            let element = this.$refs[refName];
            if (!element) {
                element = document.getElementById(refName);
            }
            if (element) {
                let top = element.offsetTop;
                window.scrollTo({
                    top: top,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        },

        changeTab(tabsName, oneTabItem, tabIndex) {
            this.elementTab = tabIndex;
            this.$emit('tabsChanged', tabsName, tabIndex);
        },

        tabsChanged(tabsName, tabsIndex) {
            this.$store.dispatch('tabs/set', [tabsName, tabsIndex]);
            let pageTabs = this._.cloneDeep(this.$store.getters['tabs/list']);
            this.$store.dispatch('tabs/clear');
            this.$nextTick(() => {
                this.$nextTick(() => {
                    this.$store.dispatch('tabs/reload', pageTabs);
                    this.$forceUpdate();
                });
            })
        },

        stripTags(data) {
            if (data) {
                data = data.replace(/(<([^>]+)>)/ig, '');
            }
            return data;
        },

        updateMetaData: function (obj) {
            this.$emit('pageMeta', obj);
        },

        forceRerender() {
            // Removing my-component from the DOM
            this.renderComponent = false;

            this.$nextTick(() => {
                // Adding the component back in
                this.renderComponent = true;
            });
        },
    },

    watch: {
        pageTabs: {
            handler(newV) {
                if (newV && newV.tabs && this.component && this.component.refTabs) {
                    this.elementTab = newV.tabs[this.component.refTabs];
                    this.$forceUpdate();
                }
            },
            deep: true
        }
    },

    filters: {
        'stripHtml': function (value) {
            const div = document.createElement('div')
            div.innerHTML = value
            return div.textContent || div.innerText || ''
        },
        'formatDate': function (value) {
            if (value) {
                return moment(String(value)).format('MM-DD-YYYY')
            }
        },


    }
}